
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 14","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.563 2.188c0-.493.14-.88.492-1.196A1.594 1.594 0 0111.215.5c.457 0 .879.14 1.23.492l5.063 5.063c.316.351.492.738.492 1.195 0 .492-.176.879-.492 1.195l-5.063 5.063c-.351.351-.773.492-1.23.492-.457 0-.844-.176-1.16-.492-.352-.317-.492-.703-.492-1.195v-1.829H6.187c-.492 0-.878-.14-1.195-.492-.351-.316-.492-.703-.492-1.195V5.703c0-.457.14-.844.492-1.195a1.616 1.616 0 011.196-.492h3.375V2.187zm6.75 5.062L11.25 2.187v3.516H6.187v3.094h5.063v3.515l5.063-5.062zM3.374.5a3.29 3.29 0 00-2.39.984A3.265 3.265 0 000 3.875v6.75c0 .95.316 1.758.984 2.39.633.669 1.442.985 2.391.985h2.953a.4.4 0 00.281-.105.447.447 0 00.141-.317v-.844c0-.105-.07-.21-.14-.28-.07-.071-.176-.142-.282-.142H3.375c-.492 0-.879-.14-1.195-.492-.352-.316-.493-.703-.493-1.195v-6.75c0-.457.141-.844.493-1.195a1.616 1.616 0 011.195-.493h2.953a.4.4 0 00.281-.105.447.447 0 00.141-.316V.922c0-.106-.07-.211-.14-.281C6.54.57 6.433.5 6.327.5H3.375z"}})])
          )
        }
      }
    